import "./src/styles/global.css"

let previousPage = '';

function detectTrafficSource(referrer) {
  if (!referrer) return '';
  try {
    const d = new URL(referrer).hostname.toLowerCase();
    if (d.includes('google.'))      return 'Google';
    if (d.includes('bing.'))        return 'Bing';
    if (d.includes('yahoo.'))       return 'Yahoo';
    if (d.includes('duckduckgo.'))  return 'DuckDuckGo';
    if (d.includes('facebook.'))    return 'Facebook';
    if (d.includes('instagram.'))   return 'Instagram';
    if (d.includes('twitter.') || d.includes('x.com')) return 'Twitter/X';
    if (d.includes('linkedin.'))    return 'LinkedIn';
    if (d.includes('youtube.'))     return 'YouTube';
    if (d.includes('tiktok.'))      return 'TikTok';
    if (d.includes('tripadvisor.')) return 'TripAdvisor';
    if (d.includes('booking.'))     return 'Booking.com';
    return d;
  } catch { return ''; }
}

function detectOrganicSource(referrer) {
  if (!referrer) return '';
  try {
    const d = new URL(referrer).hostname.toLowerCase();
    if (d.includes('google.') || d.includes('bing.') || d.includes('yahoo.') || d.includes('duckduckgo.'))
      return 'Search Engine';
    if (d.includes('facebook.') || d.includes('instagram.') || d.includes('twitter.') ||
        d.includes('x.com') || d.includes('linkedin.') || d.includes('youtube.') || d.includes('tiktok.'))
      return 'Social Media';
    if (d.includes('tripadvisor.') || d.includes('booking.') || d.includes('expedia.') || d.includes('agoda.'))
      return 'Travel Site';
    return 'Direct';
  } catch { return ''; }
}

export const onRouteUpdate = ({ location }) => {
  if (previousPage && previousPage !== location.pathname) {
    sessionStorage.setItem('previous_page', previousPage);
  }
  previousPage = location.pathname;

  if (typeof window.Weglot !== "undefined") {
    window.Weglot.initialize({ api_key: `${process.env.GATSBY_WEGLOT_API_KEY}`, original: "en" })
  } else {
    document.addEventListener("weglot-loaded", () => {
      window.Weglot.initialize({ api_key: `${process.env.GATSBY_WEGLOT_API_KEY}`, original: "en" })
    })
  }
}

export const onInitialClientRender = () => {
  // Weglot
  if (typeof window.Weglot !== "undefined") {
    window.Weglot.initialize({ api_key: `${process.env.GATSBY_WEGLOT_API_KEY}`, original: "en" })
  } else {
    document.addEventListener("weglot-loaded", () => {
      window.Weglot.initialize({ api_key: `${process.env.GATSBY_WEGLOT_API_KEY}`, original: "en" })
    })
  }

  // UTM / attribution capture
  const params = new URLSearchParams(window.location.search);

  const utmSource     = params.get('utm_source')     || '';
  const utmMedium     = params.get('utm_medium')     || '';
  const utmCampaign   = params.get('utm_campaign')   || '';
  const utmTerm       = params.get('utm_term')       || '';
  const utmContent    = params.get('utm_content')    || '';
  const gclid         = params.get('gclid')          || '';
  const leadsId       = params.get('leads_id')       || 'TSA';
  const trafficSource = params.get('traffic_source') || '';
  const organic       = params.get('organic')        || '';

  const documentReferrer = document.referrer || '';

  if (utmSource)   sessionStorage.setItem('utm_source',   utmSource);
  if (utmMedium)   sessionStorage.setItem('utm_medium',   utmMedium);
  if (utmCampaign) sessionStorage.setItem('utm_campaign', utmCampaign);
  if (utmTerm)     sessionStorage.setItem('utm_term',     utmTerm);
  if (utmContent)  sessionStorage.setItem('utm_content',  utmContent);
  if (gclid)       sessionStorage.setItem('gclid',        gclid);
  sessionStorage.setItem('leads_id', leadsId);

  if (!trafficSource && utmSource) {
    sessionStorage.setItem('traffic_source', utmSource.charAt(0).toUpperCase() + utmSource.slice(1));
  } else if (trafficSource) {
    sessionStorage.setItem('traffic_source', trafficSource);
  }

  if (gclid) {
    if (!sessionStorage.getItem('traffic_source')) sessionStorage.setItem('traffic_source', 'Google');
  }

  if (!organic && utmMedium) {
    const mediumMap = {
      organic: 'Search Engine', cpc: 'Search Engine', ppc: 'Search Engine',
      social: 'Social Media', facebook: 'Social Media', instagram: 'Social Media',
      twitter: 'Social Media', linkedin: 'Social Media', tiktok: 'Social Media',
      email: 'Email', referral: 'Referral', display: 'Display',
    };
    sessionStorage.setItem('organic', mediumMap[utmMedium.toLowerCase()] || utmMedium);
  } else if (organic) {
    sessionStorage.setItem('organic', organic);
  }

  if (documentReferrer && !documentReferrer.startsWith(window.location.origin)) {
    sessionStorage.setItem('document_referrer', documentReferrer);
    const detectedTraffic = detectTrafficSource(documentReferrer);
    const detectedOrganic = detectOrganicSource(documentReferrer);
    if (!sessionStorage.getItem('traffic_source') && detectedTraffic)
      sessionStorage.setItem('traffic_source', detectedTraffic);
    if (!sessionStorage.getItem('organic') && detectedOrganic)
      sessionStorage.setItem('organic', detectedOrganic);
  }

  previousPage = window.location.pathname;
}

export const onClientEntry = () => {
  if (typeof window !== "undefined" && !window._hsq) {
    window._hsq = [];
    const hs = document.createElement("script");
    hs.type = "text/javascript";
    hs.async = true;
    hs.src = "//js.hs-scripts.com/7849525.js";
    document.head.appendChild(hs);
  }
};
